<div class="d-flex justify-content-center align-items-center">
    <nz-card class="p-3 mb-2" style="width: 400px; height: fit-content;border-radius: 0 !important;" nzHoverable>
        <div class="d-flex justify-content-between border p-2 align-items-center gap-2">
            <div class="d-flex flex-column gap-2 col-6">
                <div class="d-flex flex-column">
                    <span class="text-muted" style="font-size: 12px;">Virtual Account Number</span>
                    <span class="" style="color: #626262;">1234567890000
                        <img src="https://storage.googleapis.com/komerce/assets/copy.svg" alt="" width="16" height="16">
                    </span>
                </div>
                <div class="d-flex flex-column">
                    <span class="text-muted" style="font-size: 12px;">Virtual Account Name</span>
                    <span class="" style="color: #626262;">Your Company Name
                    </span>
                </div>
                <div class="d-flex flex-column">
                    <span class="text-muted" style="font-size: 12px;">Amount to Pay</span>
                    <span class="" style="color: #626262;">Rp 11.000
                    </span>
                </div>
            </div>
            <div class="d-flex justify-content-center align-items-center col-6">
                <img src="https://storage.googleapis.com/komerce/assets/icons/bank_bri_full.png" alt="file"
                    width="150px" />
            </div>
        </div>
        <div class="border rounded p-2 mt-2" style="background-color: #DFF3FF;">
            <div class="d-flex flex-column">
                <span class="text-muted">Protect Yourself Against Fraud</span>
                <span class="mt-2" style="color: #626262;font-size: 12px;">Ensure the merchant's name, payment amount,
                    and
                    details are
                    correct. Always check before proceeding with payment
                </span>
            </div>
        </div>

        <div class="mt-4 flex flex-column ">
            <div class="d-flex gap-4">
                <span style="color: #08A0F7;">ATM</span>
                <span>MBANKING</span>
            </div>
            <div class="d-flex">
                <hr class="w-25" style="border-color: #08A0F7; border-width: 4px;">
                <hr class="w-75">
            </div>

            <div class="d-flex flex-column gap-2">
                <div class="d-flex flex-column">
                    <span class="text-bold">Find Nearest ATM</span>
                    <span style="font-size: 12px;">1. Insert the card, select the language, and then enter your
                        PIN</span>
                    <span style="font-size: 12px;">2. Select "Other Menu" and select "Payment"</span>
                    <span style="font-size: 12px;">3. Select "Other Payment" and select "Briva"</span>
                </div>
                <div class="d-flex flex-column">
                    <span class="text-bold">Payment Details</span>
                    <span style="font-size: 12px;">1. Enter virtual account number <span
                            style="color: #08A0F7;">1234567890000</span> and the nominal that you
                        want to pay</span>
                    <span style="font-size: 12px;">2. Check the transaction data and press "YES"</span>
                </div>
                <div class="d-flex flex-column">
                    <span class="text-bold">Transaction Completed</span>
                    <span style="font-size: 12px;">1. Once the payment transaction is completed, this Payment ID will be
                        updated automatically. This may take up to 5 minutes.</span>
                </div>
            </div>
        </div>
    </nz-card>
</div>